<template>
  <div>
    <div class="card-rent-link-triggers">
      <div class="card-rent-link-trigger" @click="createRent">
        <i class="fa-regular fa-square-plus card-rent-link-trigger-icon"></i>
        <span>Criar Locação</span>
      </div>

      <div class="card-rent-link-trigger" @click="openAddModal">
        <i class="fa-solid fa-link card-rent-link-trigger-icon"></i>
        <span>Vincular locação</span>
      </div>
    </div>

    <ModalChild
        v-model="showAddModal"
        title="Vincular Locação"
        :width="700"
        body-padding="14px 16px"
        @close="onModalClose"
    >
      <CheckboxServer
          title="Locações"
          :showSearch="true"
          url="/api/v1/rental/rent/select-all"
          v-model="selectedRentIds"
      />

      <div class="card-rent-link-modal-footer">
        <Button
            _key="btnAddRent"
            type="primary"
            title="Adicionar"
            classIcon="fa-solid fa-plus"
            size="medium"
            :loading="isLoading('btnAddRent')"
            :disabled="selectedRentIds.length === 0"
            :clicked="addRentals"
        />
      </div>
    </ModalChild>

    <CardRentLinkList class="card-rent-link-list-margin" :cardId="cardId" @count-change="$emit('count-change', $event)"/>
  </div>
</template>

<script>
import Button from "@/ui/forms/Button";
import CheckboxServer from "@/ui/forms/CheckboxServer";
import ModalChild from "@/ui/layout/ModalChild.vue";

import CardRentLinkList from "./RentLinkList.vue";
import CardService from "../../services/card.service";

import {mapGetters, mapMutations} from "vuex";

export default {
  name: "CardRentLink",
  components: {Button, CheckboxServer, ModalChild, CardRentLinkList},
  props: {
    cardId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      showAddModal: false,
      selectedRentIds: [],
    };
  },
  computed: {
    ...mapGetters("generic", ["isLoading"]),
    ...mapGetters("user", ["hasRule"]),
  },
  methods: {
    ...mapMutations("generic", ["addEvent", "removeLoading", "hideModal"]),
    openAddModal() {
      this.showAddModal = true;
    },
    createRent() {
      this.hideModal();
      if (this.hasRule("Rental")) {
        this.$router.push({name: "rentCreate", params: {type: 1}, query: {cardId: this.cardId}});
      } else if (this.hasRule("Operational")) {
        this.$router.push({name: "rentOperationalCreate", query: {cardId: this.cardId}});
      }
    },
    onModalClose() {
      this.selectedRentIds = [];
      this.addEvent({name: "cleanCheckboxServer"});
    },
    async addRentals() {
      try {
        for (const rentId of this.selectedRentIds) {
          await CardService.addRentLinked(this.cardId, rentId);
        }
        this.addEvent({name: "rentLinkedAdded"});
        this.showAddModal = false;
        this.onModalClose();
      } finally {
        this.removeLoading(["btnAddRent"]);
      }
    },
  },
};
</script>

<style scoped>
.card-rent-link-triggers {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: wrap;
}

.card-rent-link-trigger {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  border-radius: 8px;
  color: var(--text-secondary);
  font-size: 14px;
  cursor: pointer;
  transition: background 0.15s;
}

.card-rent-link-trigger:hover {
  background: var(--bg-hover);
}

.card-rent-link-trigger-icon {
  font-size: 16px;
  color: var(--text-muted);
}

.card-rent-link-modal-footer {
  display: flex;
  justify-content: center;
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid var(--border-subtle);
}

.card-rent-link-list-margin {
  margin-top: 12px;
}
</style>
